export const getCoverSrc = url => {
  return `https://res.cloudinary.com/bravado/image/fetch/w_700,f_auto,q_auto/${url}`;
};
